<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="record-head">
            <span class="period-number">{{ formatIssueDisplay(v.expect) }}</span>
            <span class="record-time">{{ formatDisplayTime(v.create_time) }}</span>
          </div>
             
          <div class="tag-row">
            <span
              v-for="citem in v.data"
              :key="citem.id"
              :class="['gift-tag', `gift-tag--${citem.type}`]"
            >
              {{ calcSize(citem.type) }}
            </span>
          </div>
              
          <div class="record-foot">
            <span class="gift-money">{{ $t('ui.order.gift_sent') }}{{ Number(v.money || 0).toFixed(2) }}</span>
            <span :class="['record-status', { 'record-status--success': v.status === 1, 'record-status--pending': v.status === 0 }]">
              {{ getDisplayStatus(v) }}
            </span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
const ISSUE_DISPLAY_BASE = 1071619;

export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size:""
      
    };
  },
  methods: {
    formatIssueDisplay(expect) {
      const issue = String(expect || '').trim();
      if (!issue) {
        return '--';
      }
      if (/^\d{1,7}$/.test(issue)) {
        return issue;
      }
      if (/^\d{10,}$/.test(issue)) {
        const sequence = parseInt(issue.slice(9), 10);
        if (!Number.isNaN(sequence)) {
          return String(ISSUE_DISPLAY_BASE + sequence);
        }
      }
      return issue;
    },
    formatDisplayTime(value) {
      const raw = String(value || '').trim();
      const match = raw.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
      if (!match) {
        return raw || '--';
      }

      const [, year, month, day, hour, minute, second] = match;
      const baseDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}+08:00`);
      if (Number.isNaN(baseDate.getTime())) {
        return raw;
      }

      const shifted = new Date(baseDate.getTime() + 60 * 60 * 1000);
      const pad = (num) => String(num).padStart(2, '0');

      return `${shifted.getFullYear()}-${pad(shifted.getMonth() + 1)}-${pad(shifted.getDate())} ${pad(shifted.getHours())}:${pad(shifted.getMinutes())}:${pad(shifted.getSeconds())}`;
    },
    normalizeOpencode(opencode){
      if (Array.isArray(opencode)) {
        return opencode.slice(0, 3).map((value) => Number(value) || 0);
      }
      if (typeof opencode === 'string' && opencode.trim()) {
        return opencode.split(/[,|]/).slice(0, 3).map((value) => Number(value) || 0);
      }
      return [];
    },
    getGiftLabel(type){
      const labelMap = {
        big: 'tinder',
        small: 'Bumble',
        one: 'Hinge',
        two: 'BADOO'
      };
      return labelMap[type] || type || '';
    },
    buildResultLabels(item){
      const opencode = this.normalizeOpencode(item && item.opencode);
      if (opencode.length < 3) {
        return {
          size: '',
          double: ''
        };
      }

      const sum = opencode[0] + opencode[1] + opencode[2];
      let size = "",double = "";
      if(sum >= 11 && sum <=18){
        size = 'tinder';
      }else if(sum >= 3 && sum <= 10){
        size = 'Bumble';
      }
      if(sum % 2 === 0){
        double = 'BADOO';
      }else {
        double = 'Hinge';
      }

      return { size, double };
    },
    getDisplayStatus(item){
      if (!item) {
        return '';
      }
      if (item.status === 0) {
        return this.$t('ui.events.sending_gift');
      }
      if (item.status === 1) {
        const payoutAmount = Number(
          typeof item.payout_amount !== 'undefined' ? item.payout_amount : item.profit || 0
        );
        return this.$t('ui.order.sent_success', { n: payoutAmount.toFixed(2) });
      }
      return item.status_text || '';
    },
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getUserGameList(true);
    },
    calcSize(el){
      return this.getGiftLabel(el);
    },
    getUserGameList(){
      this.isLoading = true;
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          let clist = res.data;
          let list = [];
          clist.map(item => {
            const { size, double } = this.buildResultLabels(item);
            item.size = size;
            item.double  = double;
            list.push({
              ...item,
              size,
              double
            })
          })
          this.list  = list;
          this.$toast.clear();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.$toast(this.$t('ui.order.toast_load_fail'));
      }).finally(() => {
        this.isLoading = false;
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  },
  activated() {
    if (localStorage.getItem('token')) {
      this.getUserGameList();
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 18px 18px 16px;
  margin: 22px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 14px;
  color: #f3c7a2;
  border: 1px solid #766350;
}
.record-head{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.item_list .period-number{
  font-size: 34px;
  font-weight: 800;
  color: #f4bf76;
  line-height: 1.2;
}

.record-time{
  color: rgba(255, 255, 255, 0.72);
  font-size: 24px;
  line-height: 1.2;
  text-align: right;
}

.tag-row{
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
  margin-bottom: 18px;
}

.gift-tag{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  padding: 8px 18px;
  border-radius: 10px;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  text-transform: lowercase;
}

.gift-tag--big{
  background: #f2cc4d;
  color: #2e2515;
}

.gift-tag--small{
  background: #ffffff;
  color: #202020;
}

.gift-tag--one{
  background: #ff4d93;
  color: #ffffff;
}

.gift-tag--two{
  background: #000000;
  color: #ffffff;
}

.record-foot{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 6px;
}

.gift-money{
  color: #f6c689;
  font-size: 30px;
  font-weight: 500;
}

.record-status{
  color: rgba(255, 255, 255, 0.78);
  font-size: 29px;
  font-weight: 700;
  text-align: right;
}

.record-status--success{
  color: #12ff53;
}

.record-status--pending{
  color: #f6d6a4;
}
</style>
